import AdvancedSearch from '@nile/components/src/Components/AdvancedSearch/AdvancedSearch';
import {
  onAttributeSelect,
  onValueSearch
} from '@nile/components/src/Pebbles/AdvancedTaskFilter';
import React from 'react';

export function TaskQueryBuilderForm(props) {
  return (
    <AdvancedSearch
      {...props}
      currentModule="task"
      onAttributeSelect={onAttributeSelect}
      onValueSearch={onValueSearch}
      isNewBuilder
    />
  );
}
